<template>
  <div class="required-block">
    <CustomCheckBox @check="clickCheck"
                    :active="item.check.requiredOne"
                    :name="prefixInput+'req'"
                    label="One account is required"/>
  </div>
</template>
<script>
import CustomCheckBox from "@/components/CustomCheckBox/CustomCheckBox.vue";

export default {
  name: 'RequiredOne',
  components: {
    CustomCheckBox
  },
  data() {
    return {}
  },
  props: {
    prefixInput: String,
    item: Object,
  },
  methods: {
    clickCheck(payload) {
      this.$props.item.check.requiredOne = payload
    },
  }
}
</script>
<style scoped lang="scss">;
.required-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: auto;
  background: #F9F9F9;
  border-bottom: none;
  .cntr {
    border: none;
    padding: 0;
    height: auto;
    background: transparent;
    label {
      padding: 0;
    }
  }
}
</style>
